import { render } from "./LoadingSpinner.vue?vue&type=template&id=00fe779f&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=00fe779f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fe779f"]])

export default __exports__